(() => {
  const selector = 'video[data-simedge-lazy-video]';
  const initializedVideos = new WeakSet();
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initializeVideo(video) {
    if (initializedVideos.has(video)) return;
    initializedVideos.add(video);

    // Keep the lightweight preview image for visitors who prefer reduced motion.
    if (prefersReducedMotion.matches) return;

    const prepareVideo = () => {
      if (video.dataset.prepared === 'true') return;

      video.dataset.prepared = 'true';
      video.preload = 'auto';
      video.load();

      const reveal = () => video.classList.add('is-ready');

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        reveal();
      } else {
        video.addEventListener('loadeddata', reveal, { once: true });
      }
    };

    const playVideo = async () => {
      prepareVideo();

      try {
        await video.play();
      } catch (_error) {
        // The preview remains visible if a browser blocks autoplay.
      }
    };

    const bufferObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          prepareVideo();
          bufferObserver.unobserve(video);
        });
      },
      {
        // Begin buffering roughly two viewports before the Sabelt section appears.
        rootMargin: '1800px 0px',
        threshold: 0.01,
      }
    );

    const playbackObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            playVideo();
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      {
        // Start playback just before the section becomes visible.
        rootMargin: '160px 0px',
        threshold: 0.01,
      }
    );

    bufferObserver.observe(video);
    playbackObserver.observe(video);
  }

  function initializeVideos(root = document) {
    root.querySelectorAll(selector).forEach(initializeVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeVideos(), { once: true });
  } else {
    initializeVideos();
  }

  document.addEventListener('shopify:section:load', (event) => initializeVideos(event.target));
})();
